import { Component, effect, inject, OnDestroy } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { Dialog } from '../dialog';
import { TextInputComponent } from '../../data-input/form-inputs/text-input/text-input.component';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { EEntityType, ERelationType, LANGUAGE_PREFIX_LENGTH } from '@web/dtos';

interface ILanguageForm {
  name: FormControl<string | null>;
  prefix: FormControl<string | null>;
}

@Component({
  selector: 'aw-reset-changes-dialog',
  templateUrl: './add-language-dialog.component.html',
  standalone: true,
  imports: [DialogComponent, TextInputComponent, ReactiveFormsModule],
})
export class AddLanguageDialogComponent
  extends Dialog<{
    name: string;
    prefix: string;
  }>
  implements OnDestroy
{
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  protected readonly EEntityType: typeof EEntityType = EEntityType;
  protected readonly ERelationType: typeof ERelationType = ERelationType;

  public newLanguageForm: FormGroup<ILanguageForm> = new FormGroup({
    name: new FormControl('', [Validators.required]),
    prefix: new FormControl('', [
      Validators.required,
      Validators.maxLength(LANGUAGE_PREFIX_LENGTH),
      Validators.minLength(LANGUAGE_PREFIX_LENGTH),
    ]),
  });
  private readonly subscription: Subscription = new Subscription();

  constructor() {
    super();
    effect((): void => {
      this.subscription.add(
        this.newLanguageForm.controls.name.valueChanges.subscribe(name => {
          if (name) {
            this.data = {
              ...this.data,
              name: name,
            };
          }
        })
      );
      this.subscription.add(
        this.newLanguageForm.controls.prefix.valueChanges.subscribe(prefix => {
          if (prefix) {
            this.data = {
              ...this.data,
              prefix: prefix,
            };
          }
        })
      );
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.newLanguageForm.patchValue({
        name: this.data.name ?? '',
        prefix: this.data.prefix ?? '',
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
